<template>
  <div class="modal-header">
    <div class="flex-center-vertical">
      <div class="headerBtns">
        <button
          v-if="canConfirm"
          class="headerBtnConfirm text-btn"
          @click="onConfirm"
        >
          {{ $t('GENERAL.SAVE') }}
        </button>
        <button
          v-if="canGoBack"
          class="headerBtnConfirm text-btn"
          @click="onGoBack"
        >
          {{ $t('GENERAL.BACK') }}
        </button>
        <button class="headerBtnCancel text-btn" @click="onCancel">
          {{ $t('SA.action.cancel') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SaveCancelModalHeader',
  props: {
    canConfirm: { type: Boolean, default: false },
    canGoBack: { type: Boolean, default: false },
    onConfirm: { type: Function, default: () => {} },
    onGoBack: { type: Function, default: () => {} },
    onCancel: { type: Function, required: true },
  },
};
</script>

<style lang="scss" scoped>
@import 'src/scss/styleguide/colors';

.headerBtns {
  width: 100%;
  font-weight: bold;
}

.headerBtnConfirm {
  margin-right: 1.5em;
}

.headerBtnCancel {
  color: $sprd-color-grey;
}
</style>
